import { clamp } from "@utils/utils";

export function LfoCycles(rate: number, rateMin: number, rateMax: number, maxCycles = 4): number {
  const rateNorm = (rate - rateMin) / Math.max(rateMax - rateMin, 0.0001);
  return clamp(rateNorm * maxCycles, 0.05, maxCycles);
}

export function LfoValue(t: number, cycles: number, depth: number, phaseDeg = 0): number {
  return depth * Math.sin(t * Math.PI * 2 * cycles + (phaseDeg / 180) * Math.PI);
}
